import React from 'react';
import styled from '@emotion/styled';

import { LayoutWithActionProps } from './types';
import DesktopPadding from '../paddings/DesktopPadding';
import colors from '../common/colors';

const BodyContainer = styled('div')`
  width: 600px;
  background-color: ${colors.white};
  box-sizing: border-box;
  padding: 32px 0;
  margin-right: 24px;

  &.xl {
    width: 792px;
  }
`;

const ButtonContainer = styled('div')`
  box-sizing: border-box;
  background-color: ${colors.white};
  padding: 28px 32px;
  height: fit-content;
  flex: 1 0 auto;
`;

const Container = styled('div')`
  width: 100%;
`;

const Content = styled('div')`
  display: flex;
`;

type DesktopSize = 'l' | 'xl';
type DesktopLayoutProps = LayoutWithActionProps & { size: DesktopSize };

function DesktopLayout(props: DesktopLayoutProps) {
  const { size, heading, info, content, button } = props;

  return (
    <Container>
      {heading}
      <Content>
        <BodyContainer className={size}>
          <DesktopPadding>
            {info}
            {content}
          </DesktopPadding>
        </BodyContainer>
        <ButtonContainer>{button}</ButtonContainer>
      </Content>
    </Container>
  );
}

export default React.memo(DesktopLayout);
